import { useEffect } from 'react';

let locks = 0;
let previousOverflow: string | null = null;

export const useBodyScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    const { body } = document;

    if (isLocked) {
      if (locks === 0) {
        previousOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
      }
      locks += 1;
    }

    return () => {
      if (typeof document === 'undefined') return;
      if (isLocked) {
        locks = Math.max(0, locks - 1);
        if (locks === 0) {
          body.style.overflow = previousOverflow ?? '';
          previousOverflow = null;
        }
      }
    };
  }, [isLocked]);
};
